import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  name: string;
  path?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="py-3">
      <ol className="flex items-center flex-wrap gap-1 text-sm text-foreground-500">
        <li>
          <Link to="/" className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
            <i className="ri-home-4-line"></i> 首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={index} className="flex items-center gap-1">
            <i className="ri-arrow-right-s-line text-xs text-foreground-400"></i>
            {item.path ? (
              <Link to={item.path} className="hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                {item.name}
              </Link>
            ) : (
              <span className="text-foreground-700 font-medium whitespace-nowrap">{item.name}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}